<template>
  <div>
    <div class="backBox" style="font-size:2rem">
      <span @click="back" class="el-icon-back"></span>
    </div>
    <!--    合并视频和书本-->
    <div v-if="merge.length !== 0 && this.gmdss.model == 1">
      <div style="margin-top:3rem;color:#0af;left:10%;text-align: center;" v-for="(item,index) in merge" :key="index">
        <el-row type="flex" justify="space-around">
          <h4 @click="getName(item)">{{ index + 1}}.{{ item.file_name }}</h4>
          <!--          <h4  @click="getName(item)" v-else :style="item.state ? 'color: red' : ''">{{ item.file_name }} </h4>-->
        </el-row>
      </div>
    </div>
    <!--    视频-->
    <div v-if="sortVideo.length !== 0 && this.gmdss.model === 2">
      <div style="margin-top:3rem;color:#0af;left:10%;text-align: center;" v-for="(item,index) in sortVideo"
           :key="index">
        <el-row type="flex" justify="space-around">
          <h4 @click="getName(item)" v-if="item.state == 1" style="color: #00b247"> {{ item.file_name }}</h4>
          <h4 @click="getName(item)" v-else :style="item.state ? 'color: red' : ''">{{ item.file_name }}</h4>
        </el-row>
      </div>
    </div>
    <div v-if="this.gmdss.model == 3">
      <div style="margin-top:3rem;color:#0af;left:10%;text-align: center;" v-for="(itemj,index) in file" :key="index">
        <el-row type="flex" justify="space-around">
          <h4 @click="getName(itemj)">{{ itemj.file_name }}</h4>
        </el-row>
      </div>
    </div>
    <div>
<!--      搜索出来的书本-->
<!--      <div v-if="this.gmdss.model == 4">-->
<!--      <div style="margin-top:3rem;color:#0af;left:10%;text-align: center;" v-for="(itemj,index) in file2" :key="index">-->
<!--        <el-row type="flex" justify="space-around">-->
<!--          <h4 @click="toolName(itemj)">{{ itemj.file_name }}d</h4>-->
<!--        </el-row>-->
<!--      </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div>-->
<!--      搜索的视频-->
      <div v-if="this.gmdss.model == 4">
      <div style="margin-top:3rem;color:#0af;left:10%;text-align: center;" v-for="(itemk,index) in getFile3" :key="index">
        <el-row type="flex" justify="space-around">
          <h4 @click="getName(itemk)">{{ itemk.file_name }}</h4>
        </el-row>
      </div>
      </div>
    </div>
    <div style="height: 3rem"></div>
  </div>
</template>

<script>
import * as req from '@/utils/request'

export default {
  data () {
    return {
      file: [],
      file2: '',
      file3: '',
      folder: '',
      videoReadList: [],
      submenuList: [],
      video: []
    }
  },
  computed: {
    // 书本视频合并
    merge () {
      let data = this.gmdss.basicsUnread
      if (data === '' || data.length === 0) {
        data = this.file
      }
      let video = this.sortVideo // 所有视频
      let model = this.gmdss.model
      if (model === 3) { // 法规 船员安全
        video = []
      }
      let objdata = []
      for (let i in video) {
        // eslint-disable-next-line eqeqeq
        if (video[i].state == 2) {
          video[i]['specific_content'] = '无'
          objdata.push(video[i])
        }
      }
      return objdata.concat(data)
    },
    getFile3 () {
      let file1 = this.file
      let file2 = this.file2
      let video = this.file3
      for (let i in video) {
        video[i].state = 2
      }
      let obj = file1.concat(file2).concat(video)
      return obj
    },
    sortVideo () {
      let user = this.gmdss.user_info
      if (!user) {
        return []
      }
      let datas = this.gmdss.videoReadList
      let data = this.video
      // 实现table 排序必读靠前
      for (let i in data) {
        data[i].state = 0 // 初始化
      }
      for (let i in data) {
        if (data[i].job != null) {
          let ARR = data[i].job
          for (let f in ARR) {
            if (ARR[f] === user.station_id) { // 当前用户岗位id等于必看视频id
              data[i].state = 2
              break
            }
          }
        }
      }
      for (let s in datas) {
        for (let f in data) {
          if (datas[s] === data[f].id) {
            data[f].state = 1 // 表示用户已播放该视频
          }
        }
      }
      // 排序 未看在顶部 已看在中间
      let result = []
      let result2 = []
      let result3 = []
      for (let i in data) {
        if (data[i].state === 2) {
          result.push(data[i])
        } else if (data[i].state === 1) {
          result2.push(data[i])
        } else {
          result3.push(data[i])
        }
      }
      result = result.concat(result2).concat(result3)
      return result
    }
  },
  methods: {
    back () {
      this.file = []
      this.file2 = []
      this.file3 = []
      window.$gmdss.Basics2 = window.$gmdss.Basics
      window.$gmdss.Basics = ''
      window.$gmdss.statutes2 = window.$gmdss.statutes
      window.$gmdss.statutes = ''
      window.$gmdss.file = []
      window.$gmdss.file2 = []
      window.$gmdss.file3 = []
      window.$gmdss.mode = 0
      this.$router.push({path: 'index'})
    },
    // 判断文件类型
    getfile_id () {
      // if (window.$gmdss.Basics === undefined && window.$gmdss.statutes === undefined && window.$gmdss.file2.list === undefined && window.$gmdss.file.list === undefined && window.$gmdss.file3.list === undefined) {
      //   window.location.href = window.$gmdss.shuxin
      // }
      if (window.$gmdss.statutes) {
        this.file = window.$gmdss.statutes
        return
      }
      if (window.$gmdss.Basics) {
        this.file = window.$gmdss.Basics
        return
      }
      if (window.$gmdss.file.list !== '') {
        if (window.$gmdss.file.list === undefined) {
          return
        }
        this.file = window.$gmdss.file.list
        if (this.file.folder === 'video') {
          this.folder = 'video'
        } else if (this.file.folder === 'tool') {
          this.folder = 'tool'
        }
      }
      if (window.$gmdss.file2.list !== '') {
        this.file2 = window.$gmdss.file2.list
      }
      if (window.$gmdss.file3.list !== '') {
        this.file3 = window.$gmdss.file3.list
      }
    },
    videoName (data) {
      // let src = this.gmdss.videoUrl + data.menu_id + '/' + data.id + '/' + data.file_name
      let src = this.gmdss.videoUrl + data.menu_id + '/' + data.id + '/' + data.name
      // debugger
      this.$router.push({path: '/video', query: {src: src}})
    },
    toolName (data) {
      let src = this.gmdss.toolUrl + data.menu_id + '/' + data.id + '/' + data.file_name
      window.location.href = src
    },
    getName (data) {
    // 用于教师端 查看当前学员最后一次学习时间 记录当前时间
      this.updateLearn()
      if (data.state === 2 || data.state === 1 || data.state === 0) {
        let src = {}
        src.path = this.gmdss.videoUrl + data.menu_id + '/' + data.id + '/' + data.name
        src.id = data.id
        src.state = data.state
        this.$router.push({path: '/video', query: {src: src}})
      } else if (window.$gmdss.file.folder === 'tool') {
        let src = this.gmdss.toolUrl + data.menu_id + '/' + data.id + '/' + data.name
        window.location.href = src
      } else {
        this.$router.push({path: '/books', query: {books: data}})
      }
    },
    updateLearn () {
      let msg = {}
      msg.id = window.$gmdss.user_info.id
      msg.times = Math.round(new Date() / 1000)
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.updateLearnfn
      sendData.vm = this
      req.Post('user/updateLearn', sendData)
    },
    updateLearnfn (data) {
      if (data.err_code !== 0) {
      }
    },
    getFolderList (filter, folder) {
      let obj = {}
      obj.folder = folder
      obj.filter = filter
      let sendData = {}
      sendData.data = obj
      sendData.fn = this.getFolderListFn
      sendData.vm = this
      req.Post('fileMenuData/get_file', sendData)
    },
    getFolderListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.video = data.list
    }
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getfile_id() // 获取首页指定菜单栏数据
      vm.getFolderList({menu_id: 200}, 'video')
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  }
}
</script>

<style scoped>
body {
  width: 100%;
}

.backBox {
  z-index: 100;
  top: 0rem;
  width: 100%;
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/file.vue